{
  "eyebrow": "Faturação e pagamento",
  "title": "Estamos quase.",
  "sub": "Prossegue para a caixa segura para iniciar a tua avaliação de 30 dias. Hoje não te cobramos nada.",
  "summary": {
    "plan": "Plano",
    "cycle": "Ciclo de faturação",
    "users": "Utilizadores",
    "vtt": "Vehicle Track & Trace",
    "vehicles": "Veículos",
    "total": "Total estimado / mês",
    "vttOn": "Incluído"
  },
  "secureNote": "Caixa segura por Stripe · 30 dias grátis · Cancela quando quiseres",
  "continue": "Continuar para o Stripe",
  "submitting": "A abrir o Stripe…",
  "canceled": {
    "title": "Pagamento cancelado",
    "sub": "Não foi feito qualquer débito. Tenta novamente ou contacta-nos se precisares de ajuda.",
    "retry": "Tentar novamente"
  },
  "promo": {
    "toggle": "Tens um código promocional?",
    "placeholder": "Código promocional",
    "apply": "Aplicar",
    "chip": "{{percent}}% de desconto",
    "remove": "Remover código promocional",
    "errorGeneric": "Não foi possível verificar o código. Tenta novamente."
  },
  "errors": {
    "generic": "Não foi possível iniciar o pagamento. Tenta novamente."
  },
  "totalUnavailable": "Catálogo de preços indisponível. Tenta novamente para carregar os preços mais recentes."
}
